import { CloseCircleOutlined, CloseOutlined, ExclamationCircleFilled, QuestionCircleTwoTone } from '@ant-design/icons'
import {
  Button,
  Popconfirm,
  TableColumnType,
  Popover,
  Col,
  Space,
  Modal,
} from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { BillingCategoryName } from '../../models/billingCategory'
import {
  getApproveFlgName,
  getChrgitmLvName,
  getMaterialsName,
  Materials,
} from '../../models/commodity'
import { Dimen } from '../../models/dimen'
import { getOtcCategoryName } from '../../models/Otccategory'
import styles from './Commodity.module.css'
import { Payment } from '../../models/payment'
import { selectMenus } from '../../layouts/layoutSlice'
import { ColDef } from 'ag-grid-community'
import moment from 'moment'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'

// 新老目录展示方式
const getProcuctInfo = (item: any, settings: any) => {
  const materialsCategory = item.materialsCategory
  const packSpec = item.packSpec ? item.packSpec : '-'
  const doseCategory = item.doseCategory ? item.doseCategory : '-'
  const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
  const spec = item.spec ? item.spec : '-'
  const model = item.model ? item.model + '/' : ''
  if (settings?.[Checks.MLKG] == 1) {
    if (materialsCategory == '0') {
      // 包装规格 + 剂型 + 生产厂家
      return packSpec + '/' + doseCategory + '/' + tenantSupplierName
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 包装规格 + 型号 + 生产厂家
      return packSpec + '/' + model + tenantSupplierName
    } else {
      // 包装规格 + 生产厂家
      return packSpec + '/' + tenantSupplierName
    }
  } else {
    if (materialsCategory == '0') {
      //包装规格 + 剂型 + 生产厂家
      return packSpec + '/' + doseCategory + '/' + tenantSupplierName
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 规格 + 包装规格 + 型号 + 生产厂家
      return spec + '/' + packSpec + '/' + model + tenantSupplierName
    } else {
      // 规格 + 包装规格 + 生产厂家
      return spec + '/' + packSpec + '/' + tenantSupplierName
    }
  }
}

export const saveDurgColumns = (startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '通用名(商品名)',
      align: 'center',
      dataIndex: 'genericName',
      key: 'genericName',
      render: (_, t) => {
        return t.genericName + (t.genericName != t.name ? `(` + t.name + `)` : '')
      },
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'packSpec',
      key: 'packSpec',
    },
    {
      title: '商品类型',
      align: 'center',
      dataIndex: 'materialsCategory',
      key: 'materialsCategory',
      render: (_, t) => {
        return getMaterialsName(t.materialsCategory)
      },
    },
    {
      title: '生产厂家',
      align: 'center',
      dataIndex: 'tenantSupplierName',
      key: 'tenantSupplierName',
    },
    {
      title: '零售价',
      align: 'right',
      dataIndex: 'retailPrice',
      key: 'retailPrice',
    },
  ]
}

export const AGColumns = (
  startIndex?: any,
  onClick?: (
    text: string,
    id: any,
    item?: any
  ) => void,
  columnList?: any,
  materialsCategory?: any,
  KFGZZCKLRSJData?: boolean,
): ColDef[] => {
  const menus = useSelector(selectMenus)

  const settings = useSelector(selectSettings)

  const [visibleId, setVisibleId] = useState<any>(null)

  const flag = menus
    ?.filter((v: any) => v?.name == 'GSP业务')?.[0]
    ?.subMenus?.filter((n: any) => n?.name == '首营管理')?.length
    ? true
    : false

  const list = materialsCategory == '0' ? columnList : columnList?.filter((v: any) => v.field != 'genericName')
  return (
    list?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        // 商品信息
        case 'name':
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getpatientName(params: any) {
              const record = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              const inventoryAlert = record.count <= (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
              return (
                <div className={styles.cellLeft}>
                  <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Col>
                      <Popover
                        content={
                          <div
                            style={{
                              height: '55px',
                              color: inventoryAlert ? 'red' : '',
                            }}
                          >
                            <p className={styles.nameText}>
                              {record.name}
                              {inventoryAlert ? '(库存预警)' : ''}
                            </p>
                            <p className={styles.productText}>
                              {getProcuctInfo(record, settings)}
                            </p>
                          </div>
                        }
                        placement='bottom'
                      >
                        <div
                          className={styles.contentText}
                          style={{ color: inventoryAlert ? 'red' : '', }}
                        >
                          <p className={styles.nameText}>
                            {record.name}
                            {inventoryAlert ? '(库存预警)' : ''}
                          </p>
                          <p className={styles.productText}>
                            {getProcuctInfo(record, settings)}
                          </p>
                        </div>
                      </Popover>
                    </Col>
                  </Space>
                </div>
              );
            },
          };
        // 通用名
        case 'genericName':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return Number(t.genericName) !== 0 ? t.genericName : '-'
            },
          };
        case 'origin':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.origin ? t?.origin : '-'
            },
          };
        // 医保国码
        case 'hilistCode':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.materialsCategory !== 4 ?
                <div className={t.hilistCode ? styles.delMedicalCode : ''}>
                  <div
                    className={styles.hilistName}
                    onClick={() => {
                      onClick && onClick('insurance', t.id, t)
                    }}
                  >
                    {t.hilistCode && <div>{t?.hilistName}</div>}
                    <div>
                      <Button type='link'>{t?.hilistCode || '匹配'}</Button>
                      {getChrgitmLvName(t?.chrgitmLv)}
                    </div>
                  </div>
                  {t.hilistCode && (
                    <span className={styles.Close}>
                      <CloseCircleOutlined
                        onClick={() => {
                          onClick && onClick('delCode', t.id, t)
                        }}
                      />
                    </span>
                  )}
                </div> : <></>
            },
          };
        // 医保限价
        case 'priceLimit':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const xj = Number(t?.priceLimit || 0).toFixed(4)
              const isOverLimit = t?.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t?.retailPrice || 0).toFixed(5));
              const limitPrice = Number(xj) > 0 && Number(xj) <= 99998 ? xj : Number(xj) == -1 ? '-' : '不限价'
              return (
                isOverLimit ?
                  <Popover
                    content={
                      <div>
                        <p>
                          零售价超医保限价！
                        </p>
                      </div>
                    }
                    placement='top'
                    title='注意'
                  >
                    <span style={{ color: 'red', fontWeight: "bold" }}>
                      {limitPrice}
                    </span>
                  </Popover>
                  :
                  <span style={{ color: t?.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
                    {limitPrice}
                  </span>
              )
            },
          };
        //  批准文号
        case 'approvalNumber':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.approvalNumber || '-';
            },
          };
        // 拆零标志
        case 'splitTag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.splitTag > 0 ? '是' : '否'
            },
          };
        // 商品类别
        case 'materialsCategory':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return getMaterialsName(t?.materialsCategory) || '-';
            },
          };
        // 开票项目
        case 'billingCategory':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return BillingCategoryName(t?.billingCategory) || '-';
            },
          };
        // 零售价
        case 'retailPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.retailPrice
                ? parseFloat(t?.retailPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        // 进价
        case 'unitPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return !KFGZZCKLRSJData ? '***' : t.unitPrice == -1 ? '-' : t.unitPrice
                ? parseFloat(t?.unitPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        // OTC标志
        case 'otc':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (BillingCategoryName(t?.billingCategory) != '中草药' &&
                t.materialsCategory == 0)
                ? getOtcCategoryName(t?.otc) || '-'
                : '-'
            },
          };
        // 是否国谈药
        case 'natNegoDrugFlag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.natNegoDrugFlag == 1 ? '是' : '否'
            },
          };
        // 是否省招
        case 'provinceTendFlag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.provinceTendFlag == 1 ? '是' : '否'
            },
          };
        // 包装材质
        case 'pacmatl':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.pacmatl || '-';
            },
          };
        // 税率
        case 'tax':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.taxStr != null && t?.taxStr !== '' ? t?.tax : '-'
            },
          };
        // 匹配状态
        case 'approveFlg':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getApproveFlg(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (!t.hilistCode ? '未匹配' :
                <Button type={Number(t?.approveFlg) ? 'link' : 'text'}>
                  {getApproveFlgName(Number(t?.approveFlg), t?.rewriteHilistCode)}
                </Button>)
            },
          };
        // 创建时间
        case 'createTime':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.createTime ? t?.createTime : '-';
            },
          };
        //   // 最近一次修改
        case 'lastUpdateTime':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getLastUpdate(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (
                <a onClick={((e) => {
                  e.preventDefault()
                  if (t?.lastUpdateTime) {
                    onClick && onClick('lastEditOperation', t?.id, t)
                  }
                })}>
                  {t?.lastUpdateTime}
                </a>)
            },
          };
        // 状态
        case 'state':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getState(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data
              return (
                <div style={{ height: '39px' }}>
                  {t.state === 1 ? (
                    <Popover
                      trigger="click"
                      title=''
                      visible={visibleId === t.id}
                      onVisibleChange={(v) => {
                        setVisibleId(v ? t.id : null)
                      }}
                      content={
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <Space style={{ lineHeight: '32px', marginBottom: '10px' }}>
                            <ExclamationCircleFilled
                              style={{
                                color: '#FFAE55',
                                fontSize: 18,
                                marginTop: '6px'
                              }}
                            /> 确认进行注销操作？
                          </Space>
                          <Space direction="vertical" size={12} className={styles.zxButtons}>
                            <Button block ghost type="primary" onClick={() => {
                              onClick && onClick('setState', t.id)
                              setVisibleId(null)
                            }} >只注销商品信息</Button>
                            <Button block danger onClick={() => {
                              setVisibleId(null)
                              Modal.confirm({
                                centered: true,
                                title: '',
                                content: (
                                  <div>
                                    <ExclamationCircleFilled
                                      style={{ color: '#FFAE55', fontSize: 18 }}
                                    />
                                    &nbsp;注销并同步删除套餐/未收费处方<br /> <span style={{ marginLeft: '24px' }}>删除后不可恢复，请谨慎操作</span>
                                  </div>
                                ),
                                okText: '确定',
                                cancelText: '取消',
                                icon: null,
                                onOk: () => {
                                  onClick && onClick('setStateForce', t.id)
                                },
                              })
                            }} >注销并删除套餐/未收费处方</Button>
                            <Button block danger onClick={() => {
                              setVisibleId(null)
                              Modal.confirm({
                                centered: true,
                                title: '',
                                content: (
                                  <div>
                                    <ExclamationCircleFilled
                                      style={{ color: '#FFAE55', fontSize: 18 }}
                                    />
                                    &nbsp;注销并同步删除商品信息和套餐/未收费处方<br /> <span style={{ marginLeft: '24px' }}>删除后不可恢复，请谨慎操作</span>
                                  </div>
                                ),
                                okText: '确定',
                                cancelText: '取消',
                                icon: null,
                                onOk: () => {
                                  onClick && onClick('setStateForceSameDelete', t.id)
                                },
                              })

                            }} >注销并删除商品信息</Button>
                          </Space></div>
                      }
                    >
                      <a
                        href='#'
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <StateSwitch value={t.state === 1} />
                      </a>
                    </Popover>
                  ) : (
                    <Popconfirm
                      title={'确认进行启用操作？'}
                      onConfirm={() => {
                        onClick && onClick('setState', t.id)
                      }}
                      onCancel={() => {
                        return
                      }}
                      okText='确认'
                      cancelText='取消'
                    >
                      <a href='#'>
                        <StateSwitch value={t.state === 1} />
                      </a>
                    </Popconfirm>
                  )}
                </div>)
            },
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getActionName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              // 确保只在合适的状态下显示退费按钮，避免重复显示
              return (
                <>
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    style={{ marginRight: '6px' }}
                    onClick={() => {
                      onClick && onClick('edit', t.id, t)
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    type='primary'
                    ghost
                    size='small'
                    style={{ marginRight: '6px' }}
                    onClick={() => {
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;您确定复制目录吗？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          onClick && onClick('copyCatalog', t.id, t)
                        },
                      })
                    }}
                  >
                    复制目录
                  </Button>
                  {flag ? (
                    <Button
                      type='primary'
                      disabled={t?.fsrId > 0 ? true : false}
                      size='small'
                      style={{ marginRight: '6px' }}
                      onClick={() => {
                        onClick && onClick('firstBusssiess', t.id, t)
                      }}
                    >
                      首营
                    </Button>
                  ) : (
                    ''
                  )}
                </>
              )
            }
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}

// 一键同步限价到售价
export const YJTBXJDSJAGColumns = (
  startIndex?: any,
  columnList?: any,
  flag?: number,
): ColDef[] => {

  const settings = useSelector(selectSettings)

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        // 商品信息
        case 'name':
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getpatientName(params: any) {
              const record = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              const inventoryAlert = record.count <= (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
              return (
                <div>
                  {flag == 1 ?
                    <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Col>
                        <Popover
                          content={
                            <div className={styles.nameOneLineTextPopover}>
                              <p>
                                {record.name}
                              </p>
                            </div>
                          }
                          placement='bottom'
                        >
                          <div className={styles.nameOneLineText}
                          >
                            {record.name}
                          </div>
                        </Popover>
                      </Col>
                    </Space> :
                    <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Col>
                        <Popover
                          content={
                            <div
                              style={{
                                height: '55px',
                                color: inventoryAlert ? 'red' : '',
                              }}
                            >
                              <p className={styles.nameText}>
                                {record.name}
                                {inventoryAlert ? '(库存预警)' : ''}
                              </p>
                              <p className={styles.productText}>
                                {getProcuctInfo(record, settings)}
                              </p>
                            </div>
                          }
                          placement='bottom'
                        >
                          <div
                            style={{
                              height: '55px',
                              overflow: 'hidden',
                              padding: '0 16px 0 0 ',
                              color: inventoryAlert ? 'red' : '',
                            }}
                          >
                            <p className={styles.nameText} >
                              {record.name}
                              {inventoryAlert ? '(库存预警)' : ''}
                            </p>
                            <p className={styles.productText}>
                              {getProcuctInfo(record, settings)}
                            </p>
                          </div>
                        </Popover>
                      </Col>
                    </Space>}
                </div>
              );
            },
          };
        // 医保国码
        case 'hilistCode':
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: { textAlign: 'left', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.materialsCategory !== 4 ?
                <div className={t.hilistCode ? styles.delMedicalCodes : ''}>
                  <div
                    className={styles.hilistNameAG}
                  >
                    {t.hilistCode && <div>{t?.hilistName}</div>}
                    <div>
                      <Button type='link' style={{ padding: '4px 6px 4px 0px' }}>{t?.hilistCode || '匹配'}</Button>
                      {getChrgitmLvName(t?.chrgitmLv)}
                    </div>
                  </div>
                </div> : <></>
            },
          };
        // 医保限价
        case 'priceLimit':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const xj = Number(t?.priceLimit || 0).toFixed(4)
              const isOverLimit = t?.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t?.retailPrice || 0).toFixed(5));
              const limitPrice = Number(xj) > 0 && Number(xj) <= 99998 ? xj : Number(xj) == -1 ? '-' : '不限价'
              return (
                isOverLimit ?
                  <Popover
                    content={
                      <div>
                        <p>
                          零售价超医保限价！
                        </p>
                      </div>
                    }
                    placement='top'
                    title='注意'
                  >
                    <span style={{ color: 'red', fontWeight: "bold" }}>
                      {limitPrice}
                    </span>
                  </Popover>
                  :
                  <span style={{ color: t?.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
                    {limitPrice}
                  </span>
              )
            },
          };
        // 目录售价
        case 'retailPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.retailPrice
                ? parseFloat(t?.retailPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}

// 一键同步售价到库存
export const YJTBXJDKCAGColumns = (
  startIndex?: any,
  columnList?: any,
): ColDef[] => {

  const settings = useSelector(selectSettings)

  // 新老目录展示方式(老目录没展示型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 生产厂家  + 包装规格  + 剂型
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格 + 型号 
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        // 生产厂家 + 规格 + 包装规格 + 剂型
        return tenantSupplierName + '/' + spec + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格 + 型号 
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        case 'name': // 商品信息
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getName(params: any) {
              if (params.node.rowPinned) {
                return '合计'
              }
              const record = params.data;
              const deadline = moment(record?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration.asDays()
              const inventoryAlert = record?.inventoryAlert && record?.inventoryAlert > 0 && record?.count < record?.inventoryAlert
              const color = days > 180 || record?.mergeFlag ? '#333333' : days > 90 ? '#027AFF' : days > 30 ? '#FA8714' : days > 0 ? 'red' : '#9564ad'
              const earlyWarningText = record?.name + ' 在库存小于 ' + record?.inventoryAlert + record?.accountUnit + ' 时预警'
              const deficiency = ' （不足' + record?.inventoryAlert + record?.accountUnit + '）'

              if (record?.name == '') {
                return ''
              } else {
                return (
                  <>
                    <Space
                      style={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Col>
                        <Popover
                          content={
                            <>
                              <div
                                style={{
                                  height: '55px',
                                  color: inventoryAlert ? 'red' : '',
                                }}
                              >
                                <p
                                  title={earlyWarningText}
                                  className={styles.nameText}
                                  style={{
                                    color: color
                                  }}
                                >
                                  <span style={{ color: inventoryAlert ? 'red' : '' }}>
                                    {record?.name}
                                  </span>
                                  {inventoryAlert ? (
                                    <span style={{ color: 'red' }}>
                                      {deficiency}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </p>
                                <p
                                  className={styles.productText}
                                  style={{ color: color }}
                                >
                                  {getProcuctInfo(record)}
                                </p>
                              </div>
                            </>
                          }
                          placement='bottom'
                        >
                          <div
                            style={{
                              height: '55px',
                              color: inventoryAlert ? 'red' : '',
                            }}
                          >
                            <p
                              title={earlyWarningText}
                              className={styles.nameText}
                              style={{
                                color: color
                              }}
                            >
                              <span style={{ color: inventoryAlert ? 'red' : '' }}>{record.name}</span>
                              {inventoryAlert ? (
                                <span style={{ color: 'red' }}>
                                  {deficiency}
                                </span>
                              ) : (
                                ''
                              )}
                            </p>
                            <p
                              className={styles.productText}
                              style={{
                                color: color,
                              }}
                            >
                              {getProcuctInfo(record)}
                            </p>
                          </div>
                        </Popover>
                      </Col>
                    </Space>
                  </>
                )
              }
            },
          };
        case 'storehouseName':// 所属库房
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getNames(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              const deadline = moment(t?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration?.asDays()
              const color = days > 180 || t.mergeFlag ? '#333333' : days > 90 ? '#027AFF' : days > 30 ? '#FA8714' : days > 0 ? 'red' : '#9564ad'

              return (
                <div style={{ color: color }}>
                  {t.mergeFlag ? '-' : val || '-'}
                </div>)
            },
          };
        case 'batchNo':  // 批次号
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getNames(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              const deadline = moment(t?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration?.asDays()
              const color = days > 180 || t.mergeFlag ? '#333333' : days > 90 ? '#027AFF' : days > 30 ? '#FA8714' : days > 0 ? 'red' : '#9564ad'

              return (
                <div style={{ color: color }}>
                  {t.mergeFlag ? '-' : val}
                </div>)
            },
          };
        case 'catalogRetailPrice': // 目录售价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: function getRetailPrice(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const deadline = moment(t?.deadline)
              const duration = moment.duration(deadline?.diff(moment()))
              const days = duration?.asDays()
              const color = days > 180 || t.mergeFlag ? '#333333' : days > 90 ? '#027AFF' : days > 30 ? '#FA8714' : days > 0 ? 'red' : '#9564ad'

              return (
                <div style={{ color: color }}>
                  {t.mergeFlag
                    ? t.retailPriceInterval
                    : parseFloat(t.catalogRetailPrice).toFixed(5)}
                </div>
              )
            },
          };
        case 'retailPrice': // 库存售价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: function getPriceTotal(params: any) {
              const t = params.data;
              const field = item.field;
              const val = Number(t?.[field])
              const deadline = moment(t.deadline)
              const duration = moment.duration(deadline.diff(moment()))
              const days = duration.asDays()
              const color = days > 180 || t.mergeFlag ? '#333333' : days > 90 ? '#027AFF' : days > 30 ? '#FA8714' : days > 0 ? 'red' : '#9564ad'

              return (
                <div style={{ color: color }}>
                  {t.mergeFlag
                    ? t.retailPriceInterval
                    : parseFloat(t.retailPrice).toFixed(5)}
                </div>
              )
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}


// 价格标签目录打印
export const JGBQMLDYAGColumns = (
  startIndex?: any,
  columnList?: any,
  deleteRow?: (text: string, record: any) => void,
): ColDef[] => {

  const settings = useSelector(selectSettings)

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'checkbox':
          return {
            ...item,
            headerClass: styles.checkCenterAligned,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
          };
        // 商品信息
        case 'name':
          return {
            ...item,
            cellStyle: { textAlign: 'left' },
            headerClass: styles.leftAligned,
            cellRendererFramework: function getpatientName(params: any) {
              const record = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              const inventoryAlert = record.count <= (record.inventoryAlert > 0 ? record.inventoryAlert : 0)
              return (
                <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Col>
                    <Popover
                      content={
                        <div
                          style={{
                            height: '55px',
                            color: inventoryAlert ? 'red' : '',
                          }}
                        >
                          <p className={styles.nameText}>
                            {record.name}
                          </p>
                          <p className={styles.productText}>
                            {getProcuctInfo(record, settings)}
                          </p>
                        </div>
                      }
                      placement='bottom'
                    >
                      <div
                        style={{
                          height: '55px',
                          overflow: 'hidden',
                          padding: '0 16px 0 0 ',
                          color: inventoryAlert ? 'red' : '',
                          cursor: 'pointer',
                        }}
                      >
                        <p className={styles.nameText} >
                          {record.name}
                        </p>
                        <p className={styles.productText}>
                          {getProcuctInfo(record, settings)}
                        </p>
                      </div>
                    </Popover>
                  </Col>
                </Space>
              );
            },
          };
        case 'origin': //产地
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.origin ? t?.origin : '-'
            },
          };
        case 'chrgitmLv': //甲乙分类
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return getChrgitmLvName(t.chrgitmLv) || '-'
            },
          };
        // 医保限价
        case 'limitPrice':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
            cellRendererFramework: function getStarName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const xj = Number(t?.limitPrice || 0).toFixed(4)
              const isOverLimit = t?.isCouldBx !== '0' && Number(xj) > 0 && Number(xj) <= 99998 && Number(xj) < Number(parseFloat(t?.retailPrice || 0).toFixed(5));
              const limitPrice = Number(xj) > 0 && Number(xj) <= 99998 ? xj : Number(xj) == -1 ? '-' : '不限价'
              return (
                isOverLimit ?
                  <Popover
                    content={
                      <div>
                        <p>
                          零售价超医保限价！
                        </p>
                      </div>
                    }
                    placement='top'
                    title='注意'
                  >
                    <span style={{ color: 'red', fontWeight: "bold" }}>
                      {limitPrice}
                    </span>
                  </Popover>
                  :
                  <span style={{ color: t?.isCouldBx !== '0' ? '#15ad31' : '#000000' }}>
                    {limitPrice}
                  </span>
              )
            },
          };
        // 售价
        case 'retailPrice':
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: { textAlign: 'right', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.retailPrice
                ? parseFloat(t?.retailPrice).toFixed(5)
                : parseFloat('0').toFixed(5)
            },
          };
        // 是否国谈药
        case 'natNegoDrugFlag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t?.natNegoDrugFlag == 1 ? '是' : '否'
            },
          };
        // 是否省招
        case 'provinceTendFlag':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return t.provinceTendFlag == 1 ? '是' : '否'
            },
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getAction(params: any) {
              const record = params.data;
              if (params.node.rowPinned) {
                return ''
              }
              return (
                <div style={{ lineHeight: '56px' }} onClick={() => deleteRow && deleteRow('delete', record)}>
                  <CloseOutlined style={{ color: '#CCCCCC', fontSize: '18px', cursor: 'pointer' }} />
                </div>
              );
            },
          };

        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}
